import React from "react";
import SomethingWentWrong from "../Components/Common/SomethingWentWrong";
import axios from "axios";
import { json } from "react-router-dom";
function getAccessTokenFromLocalStorage() {
  const { localStorage } = window;
  const token = localStorage.getItem("token");
  return token;
}
export class SlackErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    this.setState({ hasError: true });

    let key = window.btoa(error.toString());
    let clientErrors =
      JSON.parse(sessionStorage.getItem("clientErrors") || "[]") || [];
    if (!clientErrors.includes(key) || true) {
      let errorInfo = {
        message: `${error.stack.split("\n")[1]}`,
        request: {
          url: window.location.origin + window.location.pathname,
          queryString: Object.fromEntries(
            new URLSearchParams(window.location.search)
          ),
        },
        error: {
          file: error.stack.split("\n")[1],
          line: error.message,
          code: "",
          trace: info.componentStack.toString(),
        },
      };
      let payLoad = { error: errorInfo };
      // if (process.env.REACT_APP_NODE_ENV === "production") {
      //   // Send error information to the Node.js server
      // } else if (process.env.REACT_APP_NODE_ENV === "beta") {
      // } else if (process.env.REACT_APP_NODE_ENV === "stage") {
      // } else

      if (
        process.env.REACT_APP_NODE_ENV != "local" &&
        process.env.REACT_APP_NODE_ENV != "undefined"
      ) {
        axios
          .post(`${process.env.REACT_APP_API_BASE_URL}/log/error`, payLoad, {
            headers: {
              Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
            },
          })
          .then((response) => {
            console.log("Error sent to Slack:", response.data);
          })
          .catch((error) => {
            console.error("Failed to send error to Slack:", error);
          });
      } else {
        // This console happens only in development
        console.log("errorInfo", errorInfo);
      }
      sessionStorage.setItem("clientErrors", JSON.stringify([key]));
    }
  }

  render() {
    if (this.state.hasError) {
      return <SomethingWentWrong />;
    }
    return this.props.children;
  }
}
